import styles from "./styles.module.css";

interface MetricStripItem {
  value: string;
  label: string;
  note?: string;
}

interface MetricStripProps {
  items: MetricStripItem[];
}

export function MetricStrip({ items }: MetricStripProps) {
  return (
    <div className={styles.strip} data-reveal>
      {items.map((item) => (
        <div key={`${item.value}-${item.label}`} className={styles.item}>
          <span className={styles.value}>{item.value}</span>
          <span className={styles.label}>{item.label}</span>
          {item.note ? <span className={styles.note}>{item.note}</span> : null}
        </div>
      ))}
    </div>
  );
}

export default MetricStrip;
